export default {
    computed: {
        smtp() {
            return this.$store.state.smtp;
        },
        smtp_id() {
            return this.$route.params.id;
        }
    }
};
